import userStorage from '@/utils/userStorage'
import store from '@/store'

const LAST_UPDATE_DATE_KEY = 'vue-settings.lastUpdateDate'
const SETTINGS_KEY = 'vue-settings.settings'

export const SETTINGS = {
  FREIGHT_AUTO_UPDATE_INTERVAL: 'FREIGHT_AUTO_UPDATE_INTERVAL',
  MED_CHECK_DEFAULT_VALID_PERIOD: 'MED_CHECK_DEFAULT_VALID_PERIOD'
}

export function getLastUpdateDate () {
  return userStorage.getUserData(LAST_UPDATE_DATE_KEY)
}

export function setLastUpdateDate (lastUpdateDate) {
  return userStorage.setUserData(LAST_UPDATE_DATE_KEY, lastUpdateDate)
}

export function removeLastUpdateDate () {
  return userStorage.setUserData(LAST_UPDATE_DATE_KEY, null)
}

export function putSettingsToStorage (newSettings) {
  let settings = getStoredSettings()
  Object.assign(settings, newSettings)
  userStorage.setUserData(SETTINGS_KEY, settings)
}

export function getStoredSettings () {
  return userStorage.getUserData(SETTINGS_KEY) || {}
}

export default {
  SETTINGS
}



// WEBPACK FOOTER //
// ./src/utils/settings.js